<template lang="pug">
  .columns
    .column.is-12
      .columns
        .column.is-12
          h4.title.is-5 Artículos del Préstamo
      .columns
        .column.is-12
          TbAceptarItemsPrestamo(:items="items"  :prestamo="prestamo" @aceptarItem="aceptarItem" @rechazarItem="rechazarItem" @saveObservacion="saveObservacion" @deleteObservacion="deleteObservacion")
</template>

<script>
  import TbAceptarItemsPrestamo from './TbAceptarItemsPrestamo.vue'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'ContainerItemsAsignacion',
    components: { TbAceptarItemsPrestamo },
    props: {
      prestamo: {
        type: Object,
        default: () => {}
      },
      items: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        itemsAceptados: []
      }
    },
    watch: {
      itemsAceptados() {
        this.$emit('itemsAceptados', this.itemsAceptados)
      }
    },
    methods: {
      aceptarItem(data) {
        console.log('Aceptar')
        console.log(data)
        this.itemsAceptados.push(data)
        console.log(this.itemsAceptados)
        InventarioServices.aceptarItemPrestamo(data.id, this.prestamo.estado, 1)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              let catsub = ''
              if (data.subcategoria === '') {
                catsub = data.categoria
              } else {
                catsub = `${data.categoria} ${data.subcategoria}`
              }
              this.displayToast(`Se ha aceptado el item ${catsub}`, 'done', 'Ok')
            } else {
              this.displayToast(`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
          })
          .catch((error) => console.log(error))
      },
      rechazarItem(data) {
        console.log('Rechazar')
        console.log(data)
        var indexOfItem = this.itemsAceptados.findIndex(i => i.id_salida === data.id_salida)
        this.itemsAceptados.splice(indexOfItem,1)
        console.log(this.itemsAceptados)
        InventarioServices.aceptarItemPrestamo(data.id, this.prestamo.estado, 0)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              let catsub = ''
              if (data.subcategoria === '') {
                catsub = data.categoria
              } else {
                catsub = `${data.categoria} ${data.subcategoria}`
              }
              this.displayToast(`Se ha rechazado el item ${catsub}`, 'done', 'Ok')
            } else {
              this.displayToast(`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
          })
          .catch((error) => console.log(error))
      },
      saveObservacion(data) {
        console.log('saveObservacionCI')
        this.$emit('saveObservacion', data)
        
      },
      deleteObservacion(data) {
        console.log('deleteObservacionCIA')
        this.$emit('deleteObservacion', data)
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerItemsPrestamo.vue